import { render, staticRenderFns } from "./StaffAndPayroll.vue?vue&type=template&id=2b1040b6"
import script from "./StaffAndPayroll.vue?vue&type=script&lang=js"
export * from "./StaffAndPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports